import TotalSalesGraph from "../../../pages/dashboard/graphs/TotalSalesGraph";
import styled from "styled-components";

const StyledTotalBotagSales = styled.div`
    &.total-botag-sales-container {
        min-width: 320px;
        background-color: #1e2631;
        border-radius: 4px;
        padding: 16px;
        height: 116px;
    }

    .total-botag-heading {
        font-size: 12px;
        font-weight: 400;
        padding-bottom: 16px;
        text-transform: uppercase;
    }
    .total-botag-graph-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .total-botag-graph-container div h2 {
        font-size: 24px;
        font-weight: 400;
        color: #00aeef;
        padding-bottom: 12px;
    }
    .total-botag-sales-hr {
        border: 0.5px solid #3c485a;
        width: 95%;
        margin: 16px 0px;
    }
    .total-botag-footer {
        display: flex;
        justify-content: space-between;
        margin-right: 130px;
    }
`;

const TotalBotagSales = ({
    title,
    totalSalesChartSeries,
    totalValue = 0,
    totalValueCurrency = "NOK",
    subText = "--",
    options
}) => {
    return (
        <StyledTotalBotagSales className="total-botag-sales-container">
            <div className="total-botag-heading">
                <p style={{ color: "#D1D1D1" }}>
                    {title} &nbsp; <i className="fa-light fa-circle-info"></i>
                </p>
            </div>
            <div className="total-botag-graph-container">
                <div>
                    <h2>
                        {totalValue || 0} <span style={{ fontSize: "18px" }}>{totalValueCurrency}</span>
                    </h2>
                    <p style={{ color: "#D1D1D1" }}>{subText}</p>
                </div>
                <div>
                    <TotalSalesGraph type="line" height={"28px"} options={options} series={totalSalesChartSeries} />
                </div>
            </div>
        </StyledTotalBotagSales>
    );
};

export default TotalBotagSales;
